import { longDate, shortDate } from '../../helpers/usDate';

const DAY_MS = 86400000;

const plural = (n) => `${n} ${n === 1 ? 'day' : 'days'}`;

const signedOffset = (step) => (step.direction === 'before' ? -step.offset_days : step.offset_days);

export const clampDays = (value) => Math.max(0, Number.parseInt(value, 10) || 0);

export const addDays = (day, n) => {
  if (!day) return '';
  const [year, month, date] = day.split('-').map(Number);
  return new Date(Date.UTC(year, month - 1, date) + (Number(n) || 0) * DAY_MS).toISOString().slice(0, 10);
};

/**
 * A from-scratch sequence is stored as offsets from one anchor date, but edited
 * as a chain of waits. Sorting first makes every wait non-negative even for a
 * sequence written before the chain existed, and moving the anchor onto the
 * earliest step keeps every send date where it was.
 */
export const toChain = (anchorDate, serverSteps) => {
  const sorted = [...serverSteps].sort((a, b) => signedOffset(a) - signedOffset(b));

  return {
    anchor: anchorDate && sorted.length ? addDays(anchorDate, signedOffset(sorted[0])) : anchorDate || '',
    steps: sorted.map((step, i) => ({
      id: step.id,
      wait: i ? signedOffset(step) - signedOffset(sorted[i - 1]) : 0,
      channels: [...step.channels],
      template_id: step.template_id,
    })),
  };
};

export const fromChain = (steps) => {
  let offset = 0;

  return steps.map((step, i) => {
    offset += i ? step.wait : 0;
    return { id: step.id, offset_days: offset, direction: 'after', channels: step.channels, template_id: step.template_id };
  });
};

export const shortDay = (day) => shortDate(day);

export const chainDates =(anchor, steps) => {
  let day = anchor;
  return steps.map((step, i) => (day = i ? addDays(day, step.wait) : anchor));
};

export const chainSpan = (steps) => steps.slice(1).reduce((total, step) => total + step.wait, 0);

export const renewalTiming = (step) =>
  step.offset_days === 0 ? 'On the renewal date' : `${plural(step.offset_days)} ${step.direction} renewal`;

export const renewalOutOfOrder = (steps) => {
  const before = steps.filter((step) => step.direction === 'before').map((step) => step.offset_days);
  return before.some((n, i) => i > 0 && n > before[i - 1]);
};

export const chainHeading = (index, day) => {
  if (!day) return index ? 'Sends once a date is picked' : 'Sends on the date you pick — everyone at once';
  return index ? `Sends ${longDate(day)}` : `Sends ${longDate(day)} — everyone at once`;
};

export const chainRunTitle = (step, index, day) => {
  if (index === 0) return day ? `${longDate(day)} — everyone at once` : 'On the date you pick — everyone at once';
  return `${plural(step.wait)} later${day ? ` · ${longDate(day)}` : ''}`;
};
